export const GET_REQUESTS = "GET_REQUESTS";
export const GET_SINGLE_REQUESTS = "GET_SINGLE_REQUESTS";
export const REQUEST_FAILURE = "REQUEST_FAILURE";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const RESPOND_REQUESTS = "RESPOND_REQUESTS";
export const RESPOND_SUCCESS = "RESPOND_SUCCESS";
export const RESPOND_FAILURE = "RESPOND_FAILURE";

export const allRequests = (payload) => ({
  type: GET_REQUESTS,
  payload,
});

export const sinleRequest = (payload) => ({
  type: GET_SINGLE_REQUESTS,
  payload,
});
export const request_fail = (payload) => ({
  type: REQUEST_FAILURE,
  payload,
});

export const request_success = (payload) => ({
  type: REQUEST_SUCCESS,
  payload,
});

export const reponse = (payload) => ({
  type: RESPOND_REQUESTS,
  payload,
});
export const response_fail = (payload) => ({
  type: RESPOND_FAILURE,
  payload,
});

export const response_success = (payload) => ({
  type: RESPOND_SUCCESS,
  payload,
});
